/**
 * Parse a delimited list from a query param.
 * Filters out any values not present in the allowed list to guarantee validity.
 */
export const parseArrayParam = (
  raw: string | null,
  allowed: string[],
  delimiter = ",",
) => (raw?.split(delimiter) ?? []).filter((k) => allowed.includes(k));

/** Join an array of strings into a single delimited string */
export const joinArrayParam = (arr: string[], delimiter = ",") =>
  arr.join(delimiter);
